// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3UHJr","left":"InfoRow_left__3YbqT"};